import type { FunctionComponent } from 'react';

import { Button } from '@kanda-libs/ks-design-library';

import useReloadInitialData from 'hooks/useReloadInitialData';

export interface ReloadButtonProps {}

const ReloadButton: FunctionComponent<ReloadButtonProps> = function () {
  const onClick = useReloadInitialData();

  return (
    <Button.Text id="reload" icon="load" variant="ghost" onClick={onClick} />
  );
};

export default ReloadButton;
